import { render, staticRenderFns } from "./AddLayerPanel.vue?vue&type=template&id=21a52a0a&scoped=true"
import script from "./AddLayerPanel.vue?vue&type=script&lang=ts"
export * from "./AddLayerPanel.vue?vue&type=script&lang=ts"
import style0 from "./AddLayerPanel.vue?vue&type=style&index=0&id=21a52a0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a52a0a",
  null
  
)

export default component.exports